<template>
  <div
    v-show="isFullScreen"
    :style="fullScreenLines"
    class="d-flex"
    :class="isFullScreen ? 'justify-center' : ''"
  >
    <div
      class="d-flex flex-column card"
      :class="!isFullScreen ? 'mb-10' : ''"
      :style="cardStyle"
    >
      <header class="d-flex" :style="headerBackground">
        <div class="d-flex align-center">
          <!-- <div class="pa-1" style="background-color: rgb(4, 94, 94);">
                        <v-icon :size="isFullScreen ? '48' : '36'">mdi-whatsapp</v-icon>
                    </div> -->
          <span
            class="font-weight-black ml-3"
            :class="isFullScreen ? 'text-h3' : 'text-h4'"
            style="
              color: rgb(4, 94, 94);
              font-family: Fixture !important;
              text-transform: uppercase;
              text-align: center;
            "
          >
            <template v-if="flg_exibir_uf && item.dsc_uf_colaborador">
              {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
            </template>
            <template v-else>
              {{ item.dsc_nome_colaborador }}
            </template>
          </span>
        </div>
      </header>
      <section class="d-flex align-center flex-grow-1 mx-1">
        <div
          v-if="!item.dsc_tipo_midia_colaboracao"
          v-html="colabText"
          class="px-6 font-weight-medium"
          style="color: rgb(147, 38, 17); font-family: Fixture"
          :style="{ lineHeight: lineHeight, fontSize: bodyTextSize }"
        ></div>
        <div
          v-else-if="item.dsc_tipo_midia_colaboracao === 'audio'"
          style="width: 100%"
          class="d-flex align-center justify-center px-4"
        >
          <audio
            controls
            controlslist="nodownload"
            autoplay
            style="width: 100%"
            :key="item.url_midia_colaboracao"
          >
            <source :src="item.url_midia_colaboracao" />
          </audio>
        </div>
        <div
          v-else-if="
            isFullScreen &&
            item.url_midia_colaboracao &&
            ['image', 'video'].includes(item.dsc_tipo_midia_colaboracao)
          "
          :style="
            item.dsc_tipo_midia_colaboracao === 'image'
              ? 'width: 100%;'
              : 'width: 100%; display: grid; grid-template-columns: 1fr;'
          "
          :class="
            item.dsc_tipo_midia_colaboracao === 'image'
              ? 'd-flex align-center justify-center pa-2'
              : 'pa-2'
          "
          :id="`${item.id_colaboracao}-wrapper`"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            :id="`${item.id_colaboracao}`"
            :src="item.url_midia_colaboracao"
            :style="
              midiaOrientation === 'horizontal'
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                            min-width: ${
                                              (percentScreenDim.fullScreenMinWidth *
                                                screenDimensions.width) /
                                              100
                                            }px;
                                            max-height: ${
                                              (percentScreenDim.fullScreenMaxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              20
                                            }px;
                                            min-height: ${
                                              (percentScreenDim.fullScreenMinHeight *
                                                screenDimensions.height) /
                                                100 -
                                              20
                                            }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                        max-height: ${
                                          (percentScreenDim.maxHeight *
                                            screenDimensions.height) /
                                            100 -
                                          50
                                        }px`
            "
          />
          <video
            v-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            :style="
              midiaOrientation === 'horizontal'
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                max-width: ${
                                                  (percentScreenDim.fullScreenMaxWidth *
                                                    screenDimensions.width) /
                                                  100
                                                }px`
                : `max-width: 100%;
                                                max-height: ${
                                                  (percentScreenDim.maxHeight *
                                                    screenDimensions.height) /
                                                    100 -
                                                  50
                                                }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
        </div>
      </section>
      <!-- <div v-if="isFullScreen" :style="rightBorderStyle"></div> -->
      <!-- <footer class="d-flex flex-grow-1 align-center"
                :class="item.dsc_texto_colaboracao.trim().length > 40 ? 'mb-1' : ''">
                <div class="mr-7 ma-0 pa-0">
                    <span class="font-weight-bold"
                        style="font-size: 1.4rem ; color: rgb(4, 94, 94); font-family: Fixture">
                        {{ dsc_telefone_producao }}
                    </span>
                </div>
            </footer> -->
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { formatTarjaText } from "@/utils/stringUtils";

export default {
  props: {
    item: Object,
    isFullScreen: Boolean,
    posicaoCard: String,
    flg_exibir_uf: Boolean,
  },
  data() {
    return {
      dsc_telefone_producao: null,
      midiaOrientation: null,
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 40,
        minWidth: 20,
        minHeight: 30,
        maxHeight: 70,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 70,
        fullScreenMinWidth: 60,
        fullScreenMinHeight: 70,
      },
    };
  },
  async created() {
    await this.getNumTelefoneProducao();
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  computed: {
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.8rem"
          : numChars > 40 && numChars <= 80
          ? "2.5rem"
          : numChars > 80 && numChars <= 120
          ? "2.4rem"
          : numChars > 120 && numChars <= 160
          ? "2.3rem"
          : numChars > 160 && numChars <= 200
          ? "2.2rem"
          : numChars > 200 && numChars <= 240
          ? "2.1rem"
          : numChars > 240 && numChars <= 280
          ? "1.9rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.6rem"
          : numChars > 40 && numChars <= 80
          ? "2.5rem"
          : numChars > 80 && numChars <= 120
          ? "2.4rem"
          : numChars > 120 && numChars <= 160
          ? "2.3rem"
          : numChars > 160 && numChars <= 200
          ? "2.2rem"
          : numChars > 200 && numChars <= 240
          ? "2.1rem"
          : numChars > 240 && numChars <= 280
          ? "1.95rem"
          : "1.5rem";

      return lineHeight;
    },
    colabText() {
      return formatTarjaText(this.item.dsc_texto_colaboracao, "papoDeSegunda");
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    headerBackground() {
      if (this.midiaOrientation === "horizontal") {
        return "background-color: rgb(255, 165, 174);";
      }
      return "background-color: rgb(233, 150, 48);";
    },
    fullScreenLines() {
      if (this.isFullScreen) {
        const borderColor =
          this.midiaOrientation === "vertical"
            ? "rgb(147, 38, 17);"
            : "rgb(254, 248, 200)";
        const width =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          200; // 60% of screen width + 20px
        // const height = ((this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) / 100) + 50; // 80% of screen height + 50px
        return `justify-self: center; width: ${width}px; border-color: ${borderColor}; border-left-width: 3px; border-right-width: 3px; border-top-width: 0px; 
                    border-bottom-width: 0px; border-style: solid`;
      }
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-start"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";
      return position;
    },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          20; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
            100 +
          50; // 80% of screen height + 50px
        if (this.renderMode === "texto_fullscreen") {
          minWidth =
            (this.percentScreenDim.fullScreenMinWidth -
              10 * this.screenDimensions.width) /
            100;
          minHeight =
            (this.percentScreenDim.fullScreenMinHeight -
              30 * this.screenDimensions.height) /
            100;
        }
        const backgroundColor =
          this.midiaOrientation === "vertical"
            ? "rgb(147, 38, 17);"
            : "rgb(254, 248, 200)";
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                         min-width: ${minWidth}px !important; min-height: ${minHeight}px !important; background-color: ${backgroundColor}`;
        return fullScreenStyle;
      }
      const backgroundColor = "background-color: rgb(254, 248, 200);";
      const dimensions = "width: 840px; height: 240px;";
      // const position = this.posicaoCard === 'esquerda' && !this.item.url_midia_colaboracao ? 'margin-left: 100px; justify-self: flex-start'
      //         : this.posicaoCard === 'centro' ? 'justify-self: center'
      //             : this.posicaoCard === 'direita' && !this.item.url_midia_colaboracao ? 'margin-right: 40px; justify-self: flex-end'
      //                 : this.posicaoCard === 'direita' && this.item.url_midia_colaboracao ? 'margin-right: 60px; justify-self: flex-start'
      //                     : this.posicaoCard === 'esquerda' && this.item.url_midia_colaboracao ? 'margin-left: 120px; justify-self: flex-start'
      //                         : ''
      return backgroundColor
        .split(";")
        .concat(dimensions.split(";"))
        .filter((item) => item)
        .join(";");
    },
  },
  methods: {
    async getNumTelefoneProducao() {
      const cod_producao = localStorage.getItem("@socialcam/selected_option_production");
      await apiClient
        .get(`/listarDadosProducao/${cod_producao}`)
        .then((response) => {
          this.dsc_telefone_producao = response.data.producao.dsc_num_telefone;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getMidiaOrientation() {
      if (this.item.url_midia_colaboracao) {
        if (this.item.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.item.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.item.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
  },
  watch: {
    item: async function () {
      await this.getNumTelefoneProducao();
      if (this.item.url_midia_colaboracao) {
        this.getMidiaOrientation();
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Fixture";
  src: url("@/assets/fonts/Fixture-Regular.ttf") format("truetype");
}

.card {
  // background-color: rgb(254, 248, 200);
  // width: 720px;
  // height: 180px;
  // border: 1px solid #61677A;
  border-radius: 1px;
}

// header {
//     background-color: rgb(233, 150, 48);
// }

audio::-webkit-media-controls-panel {
  background-color: rgb(255, 165, 174);
}

audio::-webkit-media-controls-mute-button {
  background-color: rgb(147, 38, 17);
  border-radius: 50%;
}

audio::-webkit-media-controls-play-button {
  background-color: rgb(147, 38, 17);
  border-radius: 50%;
}

audio::-webkit-media-controls-current-time-display {
  color: rgb(254, 248, 200);
}

audio::-webkit-media-controls-time-remaining-display {
  color: rgb(254, 248, 200);
}

audio::-webkit-media-controls-timeline {
  background-color: rgb(254, 248, 200);
  border-radius: 25px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
